import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modalActionCreators from '../../actions/modal';
import CompensationSummaryReport from '../../components/CompensationSummary/CompensationSummaryContainer';
import SurveyJobMatching from '../../components/GlobalJobMatching/MatchingModal/MatchingModal';
import JDXModalIframe from '../../components/HRTMS/JDXModalIframe';
import Modal from 'ps-components/SimpleModal/Modal';
import DeleteModal from '../../components/Modal/DeleteModal';
import DeleteJobMatches from '../../components/GlobalJobMatching/DeleteMatchesModal/DeleteMatchesModal';
import SettingsModal from '../../components/Modal/SettingsModal';
import VideoPlayer from 'ps-components/VideoPlayer/VideoPlayer';

const MODAL_COMPONENTS = {
  DELETE_MODAL: DeleteModal,
  DELETE_JOB_MATCHES: DeleteJobMatches,
  VIDEO_PLAYER: VideoPlayer,
  SETTINGS_MODAL: SettingsModal,
  COMPENSATION_SUMMARY_REPORT: CompensationSummaryReport,
  SURVEY_JOB_MATCHING: SurveyJobMatching,
  JDX_IFRAME: JDXModalIframe
};

class ModalRoot extends Component {
  static propTypes = {
    actions: PropTypes.object,
    modal: PropTypes.object
  };

  componentDidMount() {
    const { actions, modalType, modalProps } = this.props;
    actions.showModal(modalType, modalProps);
  }

  render() {
    const { actions, modal } = this.props;
    if (!this.props.modal.modalType) {
      return <Modal {...this.props} />;
    }

    const SpecificModal = MODAL_COMPONENTS[this.props.modal.modalType];
    return (
      <Modal {...this.props} open={modal.open}>
        <SpecificModal {...this.props} />
      </Modal>
    );
  }
}

const mapStateToProps = ({ modal }) => ({ modal });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(modalActionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);
